
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21.5 3.9A6.4 6.4 0 0 0 17 2a6.6 6.6 0 0 0-4.6 1.9l-.4.4-.4-.4a6.4 6.4 0 0 0-9.1 0 6.7 6.7 0 0 0-2 4.6 6.6 6.6 0 0 0 1.9 4.6l8.8 8.8a1 1 0 0 0 1.4 0l8.8-8.8a6.3 6.3 0 0 0 .1-9.2z"}})])
      }
    
      }
    